var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import { Styled } from './style';
var FilterActionBar = /** @class */ (function (_super) {
    __extends(FilterActionBar, _super);
    function FilterActionBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterActionBar.prototype.render = function () {
        return (React.createElement(Styled, { isShow: this.props.selected > 0 },
            React.createElement("span", { className: "empty-element" }),
            React.createElement("div", { className: "actions-group" }, this.props.actions.map(function (action, i) { return (React.createElement(Button, { key: i, onClick: function () { return action.callback(); } }, action.actionName)); })),
            React.createElement("div", { className: "selected" },
                React.createElement("span", null,
                    " ",
                    this.props.selected,
                    " "),
                " ",
                React.createElement("span", null, this.props.for ? this.props.for : 'Items'),
                " selected")));
    };
    return FilterActionBar;
}(React.Component));
export default FilterActionBar;
//# sourceMappingURL=index.js.map